<template>
  <button
    v-bind="$attrs"
    class="px-8 py-2 rounded max-w-max shadow-sm hover:shadow-lg">
    <slot />
  </button>
</template>
